import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Button from "../../components/Common/Button/Button";
import RequestSendIcon from "../../components/Icons/RequestSendIcon";
import Header from "../../components/Header/Header";
import FixedButton from "../../components/Common/FixedButton/FixedButton";
import SuccessCheckIcon from "../../components/Icons/SuccessCheckIcon";
import styles from "../Venue/reservation.module.css";
import ContentApp from "../../components/ContentApp/ContentApp";
import { sendMessageToParent } from "@/helpers/iframe";
import WelletContext from "@/context/WelletContext";
import { useContext } from "react";

const ReservationSuccess = () => {
  const { widget } = useContext(WelletContext);
  const { t } = useTranslation();
  const { showUrl } = useParams();
  const showName = useSelector((state) => state.reservation.showName);
  const callCenter = useSelector((state) => state.reservation.callCenter);

  const handleContinue = () => {
    if (widget) {
      sendMessageToParent(window, {
        type: "CLOSE_WIDGET",
        payload: {},
      });

      window.location.href = `/venue/${showUrl}/widget`;
    } else {
      window.location.href = `/`;
    }
  };

  return (
    <>
      <Header showBack={false} title={showName} />
      <ContentApp>
        <div
          className={`d-flex align-items-center justify-content-center ${styles.iconContainer}`}
        >
          {callCenter ? (
            <RequestSendIcon color={"var(--color-primary)"} size="135px" />
          ) : (
            <SuccessCheckIcon color="var(--color-primary)" size="111px" />
          )}
        </div>
        <div className="mt-5 pt-3 px-3">
          <div className="fw-bold text-start font-large">
            {callCenter ? t("requestSent") : t("reservationConfirmed")}
          </div>
          <div className="text-secondary fw-semibold font-normal text-start mt-3">
            {callCenter
              ? t("processingRequest")
              : t("reservationWasSuccessfullyConfirmed")}
          </div>
        </div>
      </ContentApp>

      <FixedButton>
        <Button
          text={t("returnHome")}
          size="large"
          className="mt-2"
          onClick={handleContinue}
          icon={true}
          typeIcon="arrow"
          iconColor="#000"
        />
      </FixedButton>
    </>
  );
};

export default ReservationSuccess;
